import { IAppState } from '../../common/state';
import { getUser } from './getUser';

export function selectIsAgent(state: IAppState): boolean {
  const user = getUser(state);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return !user.isAuthenticated ? false : user.isAgent && !(user as any).isBuilder;
}
